import {
  ALOE_100,
  FOG_100,
  OwnUpSmallBody,
  Z_INDICES
} from '@rategravity/own-up-component-library';
import React, { PropsWithChildren } from 'react';
import styled, { CSSObject } from 'styled-components';
import HandleSVG from './handle.svg';

const sliderOverrides: CSSObject = {
  '& > div.override > div.override-track': {
    width: '100% !important' // Required to override default styling. Enables the track gradient to take up the entire width of the slider.
  },
  '& > div.override > div.override-mark': {
    position: 'relative',
    width: '100%',
    bottom: '32px',
    left: 0
  },
  '& > div.override > div.override-mark > span': {
    position: 'absolute'
  },
  '& > div.override > div.override-mark > span:first-child': {
    left: 'calc(0% + 40px) !important' // Required to override default styling. Sets the position for 'Affordable'.
  },
  '& > div.override > div.override-mark > span:last-child': {
    left: 'calc(100% - 40px) !important' // Required to override default styling. Sets the position for 'Aggressive'.
  },
  '& > div.override > div.override-handle:focus-visible': {
    boxShadow: `0 0 0 2px ${ALOE_100} !important`, // Required to override default styling. Sets the focus styling for the handle.
    outline: 'none'
  }
};

export const WrapperWithOverrides = styled.div`
  margin: 15px auto -10px; // Half the height of the handle, less half the height of the track.
  width: 100%;
  ${sliderOverrides}
`;

export const Label = ({ children }: PropsWithChildren<{}>) => (
  <OwnUpSmallBody variant="body1">{children}</OwnUpSmallBody>
);

export const handleStyle: CSSObject = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  border: `1px solid ${FOG_100}`,
  textAlign: 'center',
  boxShadow: '0 1px 8px rgba(62, 83, 81, 0.16)',
  position: 'relative',
  top: '-35px',
  backgroundColor: 'white',
  backgroundImage: `url(${HandleSVG})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: '20px',
  zIndex: Z_INDICES.DROPDOWN_OPTIONS // Somewhat arbitrarily chosen. Should sit below NAVBAR.
};

export const trackStyle: CSSObject = {
  height: '10px',
  top: '-10px',
  position: 'relative',
  borderRadius: '100px'
};

export const railStyle: CSSObject = {
  height: '10px',
  borderRadius: '100px',
  position: 'relative',
  zIndex: Z_INDICES.FORM_LABELS // Somewhat arbitrarily chosen. Should sit below NAVBAR and HANDLE.
};
